import { render, staticRenderFns } from "./BlockTabs.vue?vue&type=template&id=4569b304&scoped=true&"
import script from "./BlockTabs.vue?vue&type=script&lang=ts&"
export * from "./BlockTabs.vue?vue&type=script&lang=ts&"
import style0 from "./BlockTabs.vue?vue&type=style&index=0&id=4569b304&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4569b304",
  null
  
)

export default component.exports